(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // --- Layout Switcher Logic ---
    const resultsList = document.getElementById('ResultsList');
    const layoutButtons = document.querySelectorAll('.layout-switch-btn');
    const glider = document.querySelector('.switcher-glider');
    const storageKey = 'preferred-layout-mode';

    function updateGlider(activeBtn) {
      if (!glider || !activeBtn) return;
      glider.style.width = `${activeBtn.offsetWidth}px`;
      glider.style.left = `${activeBtn.offsetLeft}px`;
    }

    function setLayout(mode) {
      if (!resultsList) return;

      // Update Container Class
      resultsList.classList.remove('layout-mode-grid', 'layout-mode-table');
      resultsList.classList.add(`layout-mode-${mode}`);

      // Update Buttons Active State & Glider
      layoutButtons.forEach((btn) => {
        if (btn.dataset.layout === mode) {
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          updateGlider(btn);
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });

      // Save preference
      localStorage.setItem(storageKey, mode);
    }

    // Initialize logic
    if (resultsList) {
      const savedMode = localStorage.getItem(storageKey);
      const defaultMode = resultsList.dataset.defaultLayout || 'grid';
      const initialMode = savedMode || defaultMode;

      // Set initial layout
      setLayout(initialMode);

      // Ensure glider is positioned correctly after a brief delay (font loading etc)
      setTimeout(() => {
        const activeBtn = document.querySelector(`.layout-switch-btn[data-layout="${initialMode}"]`);
        updateGlider(activeBtn);
      }, 50);
    }

    // Event Listeners for Buttons (delegated or direct)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.layout-switch-btn');
      if (btn) {
        e.preventDefault();
        setLayout(btn.dataset.layout);
      }
    });

    // Handle Window Resize for Glider
    window.addEventListener('resize', () => {
      const activeBtn = document.querySelector('.layout-switch-btn.active');
      updateGlider(activeBtn);
    });

    // --- Existing Table Sort Logic ---
    const collectionContainer = document.querySelector('[data-collection-handle]');
    const collectionHandle = collectionContainer ? collectionContainer.dataset.collectionHandle : '';
    const table = document.getElementById('sortable-product-table');
    const alertMessageTemplate = document.querySelector('results-list')
      ? document.querySelector('results-list').dataset.alertMessage
      : 'Limit reached';

    if (table) {
      const headers = table.querySelectorAll('th.sortable-header');
      const tableBody = table.querySelector('tbody');
      const rows = Array.from(tableBody.querySelectorAll('tr'));
      headers.forEach((header) => {
        header.addEventListener('click', () => {
          const currentlySorted = header.classList.contains('asc') || header.classList.contains('desc');
          const direction = currentlySorted && header.classList.contains('asc') ? 'desc' : 'asc';
          headers.forEach((h) => h.classList.remove('asc', 'desc'));
          header.classList.add(direction);
          const columnIndex = Array.from(header.parentNode.children).indexOf(header);
          const sortBy = header.dataset.sortBy;
          rows.sort((rowA, rowB) => {
            const cellA = rowA.querySelectorAll('td')[columnIndex];
            const cellB = rowB.querySelectorAll('td')[columnIndex];
            let valueA = cellA.dataset.value || cellA.innerText.trim();
            let valueB = cellB.dataset.value || cellB.innerText.trim();
            if (sortBy === 'price') {
              valueA = parseFloat(valueA.replace(/[^\d.-]/g, '')) || 0;
              valueB = parseFloat(valueB.replace(/[^\d.-]/g, '')) || 0;
            }
            if (valueA < valueB) return direction === 'asc' ? -1 : 1;
            if (valueA > valueB) return direction === 'asc' ? 1 : -1;
            return 0;
          });
          rows.forEach((row) => tableBody.appendChild(row));
        });
      });
    }

    // --- Compare Logic ---
    const MAX_COMPARE = 4;
    const compareCheckboxes = document.querySelectorAll('.compare-checkbox');
    const compareBar = document.getElementById('compare-bar');
    const compareCount = document.getElementById('compare-count');
    const compareButton = document.getElementById('compare-button');
    let selectedProducts = [];

    compareCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const handle = event.target.dataset.productHandle;

        if (event.target.checked) {
          if (selectedProducts.length >= MAX_COMPARE) {
            alert(alertMessageTemplate.replace('{{ count }}', MAX_COMPARE));
            event.target.checked = false;
            return;
          }
          if (!selectedProducts.includes(handle)) {
            selectedProducts.push(handle);
          }
        } else {
          selectedProducts = selectedProducts.filter((p) => p !== handle);
        }
        updateCompareBar();
      });
    });

    function updateCompareBar() {
      if (selectedProducts.length > 0) {
        compareCount.textContent = selectedProducts.length;
        compareBar.style.display = 'block';

        if (selectedProducts.length >= 2) {
          compareButton.removeAttribute('disabled');
          const compareUrl = `/pages/compare?collection=${collectionHandle}&products=${selectedProducts.join(',')}`;
          compareButton.setAttribute('href', compareUrl);
        } else {
          compareButton.setAttribute('disabled', true);
          compareButton.setAttribute('href', '#');
        }
      } else {
        compareBar.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
